import EventsWidget from "views/logic/widgets/events/EventsWidget";
import ExportOverviewWidgetsActionComponent from "search/ExportWidgetAction/ExportOverviewWidgetsActionComponent";
const ExportEventsOverviewWidgetAction = {
  type: "export-events-overview-widget-action",
  position: "menu",
  isHidden: (w) => w.type !== EventsWidget.type,
  component: ExportOverviewWidgetsActionComponent
};
export default ExportEventsOverviewWidgetAction;
